export const EDITORIAL_PALETTES = {
  vermilion: { paper: "#f1b49a", ink: "#822e22", accent: "#d63e25" },
  moss: { paper: "#d6debb", ink: "#354b38", accent: "#77905a" },
  lilac: { paper: "#ded5e7", ink: "#524368", accent: "#9881ad" },
  ochre: { paper: "#f0d8a0", ink: "#70502b", accent: "#ca8e3e" },
  slate: { paper: "#cedee3", ink: "#345667", accent: "#729dad" },
} as const;

const CATEGORY_PALETTE: Record<string, keyof typeof EDITORIAL_PALETTES> = {
  "Люди и судьбы": "vermilion", "Власть и интриги": "lilac",
  "Войны и империи": "slate", "Наука и открытия": "moss",
  "Деньги и аферы": "ochre", "Мифы и загадки": "lilac", "Город и быт": "moss",
};

export function editorialIdentity(seed: string, category = "") {
  let hash = 0;
  for (const char of seed) hash = (Math.imul(hash, 31) + char.codePointAt(0)!) >>> 0;
  const palette = CATEGORY_PALETTE[category] || (Object.keys(EDITORIAL_PALETTES) as Array<keyof typeof EDITORIAL_PALETTES>)[hash % 5];
  return { ...EDITORIAL_PALETTES[palette], variant: hash % 3 };
}
